import React, { useState } from 'react';
import { Star, X, Calendar } from 'lucide-react';
import ImageWrapper from "@/components/ImageComponent/ImageWrapper";

const sampleReviews = [
  {
    "name": "places/ChIJuU73SL0RrjsRMNDzSXUagjk/reviews/Ci9DQUlRQUNvZENodHljRjlvT2tSQlIzUm5jbHA0YTBveU5rOXhXRk14Vm5GTk5WRRAB",
    "relativePublishTimeDescription": "3 weeks ago",
    "rating": 5,
    "text": {
      "text": "Pandit Sudhamay Chakraborty did our Griha Pravesh puja. He was very patient and knowledgeable. Having a smooth experience with bookmypuja.",
      "languageCode": "en"
    },
    "originalText": {
      "text": "Pandit Sudhamay Chakraborty did our Griha Pravesh puja. He was very patient and knowledgeable. Having a smooth experience with bookmypuja.",
      "languageCode": "en"
    },
    "authorAttribution": {
      "displayName": "Devarpita Sinha",
      "uri": "https://www.google.com/maps/contrib/105818158992435788964/reviews",
    },
    "publishTime": "2025-08-02T12:37:36.981201091Z",
    "flagContentUri": "https://www.google.com/local/review/rap/report?postId=Ci9DQUlRQUNvZENodHljRjlvT2tSQlIzUm5jbHA0YTBveU5rOXhXRk14Vm5GTk5WRRAB&d=17924085&t=1",
    "googleMapsUri": "https://www.google.com/maps/reviews/data=!4m6!14m5!1m4!2m3!1sCi9DQUlRQUNvZENodHljRjlvT2tSQlIzUm5jbHA0YTBveU5rOXhXRk14Vm5GTk5WRRAB!2m1!1s0x3bae11bd48f74eb9:0x39821a7549f3d030"
  },
  {
    "name": "places/ChIJuU73SL0RrjsRMNDzSXUagjk/reviews/Ci9DQUlRQUNvZENodHljRjlvT20xSVUyUjFXUzFuWjNCWk9HTTJjRlJSZEZwak0zYxAB",
    "relativePublishTimeDescription": "a month ago",
    "rating": 5,
    "text": {
      "text": "We had booked Griha Pravesh Puja from BookMyPooja, it was a very easy and smooth process, complete online process with regular updates from Pandit Ji being assigned till the completion, proper details of each package was explained with proper bifurcation of what Pandit Ji will bring & what we need to arrange, Pandit Ji did very good Pooja with proper detailed explanation and complete rituals, it was a very divine experience and we felt very good with the way Pooja was done, thanks & Kudos to the BookMyPooja team..",
      "languageCode": "en"
    },
    "originalText": {
      "text": "We had booked Griha Pravesh Puja from BookMyPooja, it was a very easy and smooth process, complete online process with regular updates from Pandit Ji being assigned till the completion, proper details of each package was explained with proper bifurcation of what Pandit Ji will bring & what we need to arrange, Pandit Ji did very good Pooja with proper detailed explanation and complete rituals, it was a very divine experience and we felt very good with the way Pooja was done, thanks & Kudos to the BookMyPooja team..",
      "languageCode": "en"
    },
    "authorAttribution": {
      "displayName": "Saggy",
      "uri": "https://www.google.com/maps/contrib/110713078444846006011/reviews"
    },
    "publishTime": "2025-07-14T17:47:38.755276752Z",
    "flagContentUri": "https://www.google.com/local/review/rap/report?postId=Ci9DQUlRQUNvZENodHljRjlvT20xSVUyUjFXUzFuWjNCWk9HTTJjRlJSZEZwak0zYxAB&d=17924085&t=1",
    "googleMapsUri": "https://www.google.com/maps/reviews/data=!4m6!14m5!1m4!2m3!1sCi9DQUlRQUNvZENodHljRjlvT20xSVUyUjFXUzFuWjNCWk9HTTJjRlJSZEZwak0zYxAB!2m1!1s0x3bae11bd48f74eb9:0x39821a7549f3d030"
  },
  {
    "name": "places/ChIJuU73SL0RrjsRMNDzSXUagjk/reviews/Ci9DQUlRQUNvZENodHljRjlvT25GV2VVYzVSMDlMVlVoQlNVOUpZamRoTldaTlkxRRAB",
    "relativePublishTimeDescription": "2 weeks ago",
    "rating": 5,
    "text": {
      "text": "We had a fabulous experience with Book my Pooja. It was hassle free and easy from start to finish. Narsimha was very informative and helped us choose a Pooja that we wanted. Additionally, the pandit came on time and with all the Pooja samagri. We were over all very happy with the entire experience.",
      "languageCode": "en"
    },
    "originalText": {
      "text": "We had a fabulous experience with Book my Pooja. It was hassle free and easy from start to finish. Narsimha was very informative and helped us choose a Pooja that we wanted. Additionally, the pandit came on time and with all the Pooja samagri. We were over all very happy with the entire experience.",
      "languageCode": "en"
    },
    "authorAttribution": {
      "displayName": "Neena Kannan",
      "uri": "https://www.google.com/maps/contrib/110471175298607578819/reviews"
    },
    "publishTime": "2025-08-08T04:46:12.467222024Z",
    "flagContentUri": "https://www.google.com/local/review/rap/report?postId=Ci9DQUlRQUNvZENodHljRjlvT25GV2VVYzVSMDlMVlVoQlNVOUpZamRoTldaTlkxRRAB&d=17924085&t=1",
    "googleMapsUri": "https://www.google.com/maps/reviews/data=!4m6!14m5!1m4!2m3!1sCi9DQUlRQUNvZENodHljRjlvT25GV2VVYzVSMDlMVlVoQlNVOUpZamRoTldaTlkxRRAB!2m1!1s0x3bae11bd48f74eb9:0x39821a7549f3d030"
  },
  {
    "name": "places/ChIJuU73SL0RrjsRMNDzSXUagjk/reviews/Ci9DQUlRQUNvZENodHljRjlvT25aNVdscFZUbTVVZDNKaVVrTklVVnA1Vm5OTlIxRRAB",
    "relativePublishTimeDescription": "2 weeks ago",
    "rating": 5,
    "text": {
      "text": "We booked a Poojari through BookMyPooja for our House Warming ceremony, and were assigned Datta Guru garu. He conducted the pooja exceptionally well, impressing every guest with how beautifully a traditional Telugu House Warming can be performed in Bengaluru. I would highly recommend him.",
      "languageCode": "en"
    },
    "originalText": {
      "text": "We booked a Poojari through BookMyPooja for our House Warming ceremony, and were assigned Datta Guru garu. He conducted the pooja exceptionally well, impressing every guest with how beautifully a traditional Telugu House Warming can be performed in Bengaluru. I would highly recommend him.",
      "languageCode": "en"
    },
    "authorAttribution": {
      "displayName": "Priyatham Vinnakota",
      "uri": "https://www.google.com/maps/contrib/101828446615556527395/reviews"
    },
    "publishTime": "2025-08-11T14:17:40.903598535Z",
    "flagContentUri": "https://www.google.com/local/review/rap/report?postId=Ci9DQUlRQUNvZENodHljRjlvT25aNVdscFZUbTVVZDNKaVVrTklVVnA1Vm5OTlIxRRAB&d=17924085&t=1",
    "googleMapsUri": "https://www.google.com/maps/reviews/data=!4m6!14m5!1m4!2m3!1sCi9DQUlRQUNvZENodHljRjlvT25aNVdscFZUbTVVZDNKaVVrTklVVnA1Vm5OTlIxRRAB!2m1!1s0x3bae11bd48f74eb9:0x39821a7549f3d030"
  },
  {
    "name": "places/ChIJuU73SL0RrjsRMNDzSXUagjk/reviews/ChZDSUhNMG9nS0VJQ0FnTURvdW91VVB3EAE",
    "relativePublishTimeDescription": "a month ago",
    "rating": 5,
    "text": {
      "text": "Great service provided by the company for my new car pooja. Being new to Bangalore, I was unsure about getting pundit ji. After coming across bookmypooja, i was able to book pundit ji at my convenient time and place. Pooja was also done with all rituals",
      "languageCode": "en"
    },
    "authorAttribution": {
      "displayName": "Vishal Gupta"
    },
    "publishTime": "2025-04-24T03:56:35.602592Z"
  },
  {
    "name": "places/ChIJuU73SL0RrjsRMNDzSXUagjk/reviews/Ci9DQUlRQUNvZENodHljRjlvT25acE1FOWtObEIyUzB4alJVSlNSelZLWkdaNlMzYxAB",
    "relativePublishTimeDescription": "2 weeks ago",
    "rating": 5,
    "text": {
      "text": "Organised a New Office Puja via BookMyPooja. It was on super short notice but they were very helpful and co-operative. They followed up on everything and offered a lot of assistance. The Pooja/Havan itself was very detailed and surpassed our expectations. The decorations (Alankar) was also very beautiful. Overall, a highly satisfactory experience.",
      "languageCode": "en"
    },
    "authorAttribution": {
      "displayName": "Durga Shetty"
    },
    "publishTime": "2025-06-03T06:13:25.298376918Z"
  },
  {
    "name": "places/ChIJuU73SL0RrjsRMNDzSXUagjk/reviews/ChRDSUhNMG9nS0VJQ0FnSUNINDlvQhAB",
    "relativePublishTimeDescription": "9 months ago",
    "rating": 5,
    "text": {
      "text": "I had a great experience with the service provided. I was so worried of how things will be managed but connecting with BookmyPooja helped me. The executive helped me arranging for the Pandit according to my requirements also managed the everything with regular follow up. I am very happy and would recommend this to my family and friends. The best part that i liked is the quick response and easy connect. Any query or doubts are cleared immediately. The Pandit assigned was so cooperative and conducted the pooja very well. He also explained the rituals followed and the kids of my family got to know more about it. Very Happy to say my overall experience was amazing. Thank you for making things so easy for us.\nNeha Reddy.",
      "languageCode": "en"
    },
    "authorAttribution": {
      "displayName": "Neha Reddy"
    },
    "publishTime": "2024-09-08T10:25:15.271242Z"
  },
  {
    "name": "places/ChIJuU73SL0RrjsRMNDzSXUagjk/reviews/ChZDSUhNMG9nS0VMLVBrTVRBNXBMcERREAE",
    "relativePublishTimeDescription": "3 weeks ago",
    "rating": 5,
    "text": {
      "text": "I requested an e-pooja with Book my Pooja service. The response was very quick, efficient and empathetic, I also shared my budget limitations and they did their best to carry everything out with care and ease. I am very grateful for their patience and pooja arrangements. They made sure to engage dedicated panditjis and carried out the whole process smoothly and also made sure to record one part of pooja that I missed due to some wifi issues. I really appreciate their understanding and respect towards the sacred duty of pooja rituals and the emotions of the families who need to do the rituals, but cannot be there physically. Thank you Book my Pooja and to Narasimhan sir and his supportive staff. This pooja meant a lot to me, as it was for my dearest mom. I would recommend Book my Pooja to anyone I know, without hesitation.",
      "languageCode": "en"
    },
    "authorAttribution": {
      "displayName": "manmeet khalsa"
    },
    "publishTime": "2025-05-22T22:15:57.590029Z"
  },
  {
    "name": "places/ChIJuU73SL0RrjsRMNDzSXUagjk/reviews/ChdDSUhNMG9nS0VJQ0FnTUNJM3RpWXdnRRAB",
    "relativePublishTimeDescription": "2 months ago",
    "rating": 5,
    "text": {
      "text": "We had a great experience with BookMyPooja team,\nFor preparations also the guidelines were very much clear. Very happy with the way the Pandit ji held the pooja. He was very clear and explained all the rituals well.\nOver all a wonderful experience",
      "languageCode": "en"
    },
    "authorAttribution": {
      "displayName": "akshata naik"
    },
    "publishTime": "2025-04-02T07:09:44.896995Z"
  }
]
const GoogleReviews = ({ reviews }) => {
    const [selectedReview, setSelectedReview] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const reviewsData = {
        "reviews": reviews || sampleReviews
    };

    const truncateText = (text, maxLength = 100) => {
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };

    const openModal = (review) => {
        setSelectedReview(review);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setSelectedReview(null);
        setIsModalOpen(false);
    };

    const renderStars = (rating) => {
        return Array.from({ length: 5 }, (_, i) => (
            <Star
                key={i}
                className={`w-4 h-4 ${i < rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'
                    }`}
            />
        ));
    };

    const getInitials = (name) => {
        return name.split(' ').map(n => n[0]).join('').toUpperCase();
    };

    const formatText = (text) => {
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                {index < text.split('\n').length - 1 && <br />}
            </React.Fragment>
        ));
    };

    return (
        <div className="w-full bg-white">
            {/* Header */}
            <div className="mb-4 pb-2 border-b border-gray-200">
                <h3 className="text-lg font-medium text-gray-900">Google Reviews</h3>
            </div>

            {/* Reviews Container */}
            <div className="overflow-x-auto">
                <div className="flex gap-4 pb-4" style={{ width: 'max-content' }}>
                    {reviewsData.reviews.map((review, index) => (
                        <div
                            key={index}
                            className="flex-shrink-0 w-80 h-54 bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col"
                        >
                            {/* Review Header */}
                            <div className="flex items-start justify-between mb-3">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-medium text-sm overflow-hidden">
                                        <ImageWrapper
                                            src={''}
                                            alt={review.authorAttribution.displayName}
                                            className="w-10 h-10 rounded-full object-cover"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.nextSibling.style.display = 'flex';
                                            }}
                                        />
                                        <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-medium text-sm" style={{ display: 'none' }}>
                                            {getInitials(review.authorAttribution.displayName)}
                                        </div>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-900 text-sm">
                                            {review.authorAttribution.displayName}
                                        </h4>
                                        <p className="text-xs text-gray-500">
                                            {review.relativePublishTimeDescription}
                                        </p>
                                    </div>
                                </div>
                                {/*<button className="p-1 hover:bg-gray-100 rounded-full">*/}
                                {/*    <MoreHorizontal className="w-4 h-4 text-gray-400" />*/}
                                {/*</button>*/}
                            </div>

                            {/* Rating */}
                            <div className="flex items-center gap-1 mb-3">
                                {renderStars(review.rating)}
                            </div>

                            {/* Review Text */}
                            <div className="mb-4 flex-1">
                                <p className="text-sm text-gray-700 leading-relaxed">
                                    {truncateText(review.text.text)}
                                    {review.text.text.length > 100 && (
                                        <button
                                            onClick={() => openModal(review)}
                                            className="text-blue-600 hover:text-blue-800 ml-1 font-medium"
                                        >
                                            Read more
                                        </button>
                                    )}
                                </p>
                            </div>

                            {/* Review Actions */}
                            <div className="flex items-center justify-between text-xs text-gray-500 mt-auto">
                                <div className="flex items-center gap-4">
                                    <button className="flex items-center gap-1 hover:text-gray-700 transition-colors">
                                        <Calendar className="w-3 h-3" />
                                        <span>  {new Date(review.publishTime).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Scroll indicator */}
            <div className="flex justify-center mt-2">
                <div className="flex gap-1">
                    {reviewsData.reviews.map((_, index) => (
                        <div
                            key={index}
                            className="w-2 h-2 rounded-full bg-gray-300"
                        />
                    ))}
                </div>
            </div>

            {/* Modal */}
            {isModalOpen && selectedReview && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto">
                        {/* Modal Header */}
                        <div className="flex items-center justify-between p-6 border-b border-gray-200">
                            <div className="flex items-center gap-3">
                                <div className="w-12 h-12 rounded-full bg-blue-500 flex items-center justify-center text-white font-medium overflow-hidden">
                                    <img
                                        src={''}
                                        alt={selectedReview.authorAttribution.displayName}
                                        className="w-12 h-12 rounded-full object-cover"
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                        }}
                                    />
                                    <div className="w-12 h-12 rounded-full bg-blue-500 flex items-center justify-center text-white font-medium" style={{ display: 'none' }}>
                                        {getInitials(selectedReview.authorAttribution.displayName)}
                                    </div>
                                </div>
                                <div>
                                    <h4 className="font-medium text-gray-900 text-base">
                                        {selectedReview.authorAttribution.displayName}
                                    </h4>
                                    <p className="text-sm text-gray-500">
                                        {selectedReview.relativePublishTimeDescription}
                                    </p>
                                </div>
                            </div>
                            <button
                                onClick={closeModal}
                                className="p-2 hover:bg-gray-100 rounded-full"
                            >
                                <X className="w-5 h-5 text-gray-400" />
                            </button>
                        </div>

                        {/* Modal Content */}
                        <div className="p-6">
                            {/* Rating */}
                            <div className="flex items-center gap-1 mb-4">
                                {renderStars(selectedReview.rating)}
                            </div>

                            {/* Full Review Text */}
                            <div className="mb-6">
                                <p className="text-gray-700 leading-relaxed">
                                    {formatText(selectedReview.text.text)}
                                </p>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex items-center justify-between text-sm text-gray-500 border-t border-gray-200 pt-4">
                                <div className="flex items-center gap-6">
                                </div>
                                <p className="text-xs text-gray-400">
                                    {new Date(selectedReview.publishTime).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GoogleReviews;